//Show the scoring leaders of a given League
//This here is a page that OUTPUTS that list.
import React, { useState, useEffect, useMemo, useRef } from 'react'
import { useParams, Link } from 'react-router-dom'
import './Leaders.css'
import ErrorModal from '../../shared/components/UIElements/ErrorModal'
import HeadsUpModal from '../../shared/components/UIElements/HeadsUpModal'
import LoadingSpinner from '../../shared/components/UIElements/LoadingSpinner'
//import StatsAndStandingsHome from '../../shared/components/Navigation/StatsAndStandingsHome'
//import StatsAndStandingsHomeNavigation from '../../shared/components/Navigation/StatsAndStandingsHomeNavigation'
import ScoringLeadersHomeNavigation from '../../shared/components/Navigation/ScoringLeadersHomeNavigation'
//import SearchByLeagueForScoringLeaders from '../../shared/components/UIElements/SearchByLeagueForScoringLeaders'
import SelectLeagueForScoringLeaders from '../../shared/components/UIElements/SelectLeagueForScoringLeaders'
import Banner from '../../shared/components/Navigation/Banner'
import sLogo from '../../images/s_logo_png.png'

const Leaders = () => {
	const [error, setError] = useState()
	const [isLoading, setIsLoading] = useState(false)
	const [loadedLeaders, setLoadedLeaders] = useState()
	const [leagueName, setLeagueName] = useState()
	const [session, setSession] = useState()
	const [year, setYear] = useState()
	const [divisionName, setDivisionName] = useState()
	const leagueId = useParams().leagueId
	const [isMobile440, setIsMobile440] = useState(false)
	const [activeLeaderView, setActiveLeaderView] = useState('runners')

	const [isMobile, setIsMobile] = useState(window.innerWidth <= 440)

	// NEW
	const [selectedDivision, setSelectedDivision] = useState('All Divisions')
	const [showDivisionDropdown, setShowDivisionDropdown] = useState(false)
	const divisionDropdownRef = useRef(null)

	useEffect(() => {
		const handleResize = () => {
			setIsMobile(window.innerWidth <= 440)
		}

		window.addEventListener('resize', handleResize)
		return () => window.removeEventListener('resize', handleResize)
	}, [])

	//Tap into League backend, getScoringLeadersByLeagueId in league-controller
	useEffect(() => {
		if (!leagueId) return
		const sendRequest = async () => {
			//console.log('leagueId in Leaders: ' + leagueId)
			setIsLoading(true)
			try {
				const response = await fetch(
					`${process.env.REACT_APP_BACKEND_URL}/league/${leagueId}/scoringLeaders`,
				)

				const responseData = await response.json()

				if (!response.ok) {
					throw new Error(responseData.message)
				}

				if (
					responseData.scoringLeaders &&
					responseData.scoringLeaders[0] &&
					responseData.scoringLeaders[0].divisionName
				) {
					setDivisionName(responseData.scoringLeaders[0].divisionName)
				} else {
					setDivisionName('')
				}

				setLoadedLeaders(responseData.scoringLeaders)
				setLeagueName(responseData.leagueName)
				setSession(responseData.session)
				setYear(responseData.year)
				setIsLoading(false)
			} catch (err) {
				setError(err.message)
				setLoadedLeaders('')
				setLeagueName('')
				setSession('')
				setYear('')
			}
			setIsLoading(false)
		}
		sendRequest()
	}, [leagueId])
	//
	//
	// close division dropdown on outside click
	useEffect(() => {
		const handleClickOutside = (event) => {
			if (
				divisionDropdownRef.current &&
				!divisionDropdownRef.current.contains(event.target)
			) {
				setShowDivisionDropdown(false)
			}
		}

		document.addEventListener('mousedown', handleClickOutside)
		return () => {
			document.removeEventListener('mousedown', handleClickOutside)
		}
	}, [])
	//
	//
	// distinct divisions for dropdown
	const divisionOptions = useMemo(() => {
		if (!loadedLeaders || loadedLeaders.length === 0) return ['All Divisions']

		const uniqueDivisions = [
			...new Set(
				loadedLeaders
					.map((player) => player.divisionName)
					.filter((division) => division && division.trim() !== ''),
			),
		].sort()

		return ['All Divisions', ...uniqueDivisions]
	}, [loadedLeaders])
	//
	//
	// add points + sort + filter
	const displayedLeaders = useMemo(() => {
		if (!loadedLeaders || loadedLeaders.length === 0) return []

		const leadersWithPoints = loadedLeaders.map((player) => ({
			...player,
			points:
				(player.goals || 0) +
				(player.assists || 0) +
				(player.playoffGoals || 0) +
				(player.playoffAssists || 0),
		}))

		const filteredLeaders =
			selectedDivision === 'All Divisions'
				? leadersWithPoints
				: leadersWithPoints.filter(
						(player) => player.divisionName === selectedDivision,
					)

		return filteredLeaders
			.sort((a, b) => {
				// highest points first
				if (b.points !== a.points) return b.points - a.points

				// tiebreaker: highest goals first
				if ((b.goals || 0) !== (a.goals || 0))
					return (b.goals || 0) - (a.goals || 0)

				// optional extra tiebreaker: highest assists first
				return (b.assists || 0) - (a.assists || 0)
			})
			.slice(0, 50)
	}, [loadedLeaders, selectedDivision])
	//
	//
	const displayedGoalies = useMemo(() => {
		if (!loadedLeaders || loadedLeaders.length === 0) return []

		return loadedLeaders
			.filter((player) => player.isGoalie)
			.map((goalie) => {
				const gamesPlayed = Number(goalie.goalieGamesPlayed || 0)
				const goalsAgainst = Number(goalie.goalsAgainst || 0)

				return {
					...goalie,
					gamesPlayed,
					goalsAgainst,
					gaa:
						gamesPlayed > 0
							? Math.round((goalsAgainst / gamesPlayed) * 100) / 100
							: 0,
				}
			})
			.sort((a, b) => {
				if (a.gamesPlayed === 0 && b.gamesPlayed > 0) return 1
				if (b.gamesPlayed === 0 && a.gamesPlayed > 0) return -1

				if (a.gaa !== b.gaa) return a.gaa - b.gaa

				if ((b.goalieWins || 0) !== (a.goalieWins || 0)) {
					return (b.goalieWins || 0) - (a.goalieWins || 0)
				}

				if ((b.goalieShutouts || 0) !== (a.goalieShutouts || 0)) {
					return (b.goalieShutouts || 0) - (a.goalieShutouts || 0)
				}

				return b.gamesPlayed - a.gamesPlayed
			})
	}, [loadedLeaders])
	//
	//
	const errorHandler = () => {
		setError(null)
	}

	return (
		<React.Fragment>
			<ScoringLeadersHomeNavigation leagueId={leagueId} />
			<HeadsUpModal error={error} onClear={errorHandler} />

			{isLoading && (
				<div className='center'>
					<LoadingSpinner />
				</div>
			)}

			{!isLoading && loadedLeaders && loadedLeaders.length > 0 && (
				<div className='Leaders'>
					{!isMobile && (
						<>
							<h1>Stat Leaders</h1>

							<h1>{leagueName}</h1>

							<h2>
								{session} {year}
							</h2>
						</>
					)}

					{isMobile && (
						<div className='statLeadersHero'>
							<div className='standingsHeroTop'>
								<div className='standingsHeroLine'></div>

								<div className='standingsHeroLogoCircle'>
									<img src={sLogo} alt='Shirey logo' />
								</div>

								<div className='standingsHeroLine'></div>
							</div>

							<h1>Stat Leaders</h1>

							<div className='statLeadersHero__pill'>
								{session} {year} {leagueName}
							</div>

							<p>Click on a player name to view their player page</p>
						</div>
					)}

					<div className='leaderToggle'>
						<button
							className={`leaderToggleButton ${
								activeLeaderView === 'runners' ? 'activeLeaderToggle' : ''
							}`}
							onClick={() => setActiveLeaderView('runners')}
						>
							Runners
						</button>

						<button
							className={`leaderToggleButton ${
								activeLeaderView === 'goalies' ? 'activeLeaderToggle' : ''
							}`}
							onClick={() => setActiveLeaderView('goalies')}
						>
							Goalies
						</button>
					</div>

					{/* <p style={{ textAlign: 'center' }}>
						(Click on a player name to see their individual stats)
					</p> */}

					{activeLeaderView === 'runners' && (
						<p style={{ textAlign: 'center', fontSize: 'xx-small' }}>
							(GWG: Game-Winning Goals)
						</p>
					)}

					{activeLeaderView === 'runners' && (
						<table id='bottomRoster'>
							<thead>
								<tr>
									<th>Name</th>
									<th>Team</th>

									<th
										className='divisionFilterHeader'
										ref={divisionDropdownRef}
									>
										<div
											className='divisionHeaderInner'
											onClick={() => setShowDivisionDropdown((prev) => !prev)}
										>
											Division{' '}
											<span className='divisionCaret'>
												{showDivisionDropdown ? '▲' : '▼'}
											</span>
										</div>

										{showDivisionDropdown && (
											<div className='divisionDropdownMenu'>
												{divisionOptions.map((division, index) => (
													<div
														key={index}
														className={`divisionDropdownItem ${
															selectedDivision === division
																? 'selectedDivisionItem'
																: ''
														}`}
														onClick={() => {
															setSelectedDivision(division)
															setShowDivisionDropdown(false)
														}}
													>
														{division}
													</div>
												))}
											</div>
										)}
									</th>

									<th>G</th>
									<th>A</th>
									<th>GWG</th>
									<th>PIM</th>
									<th>Total</th>
								</tr>
							</thead>

							<tbody>
								{displayedLeaders.map((player, key) => (
									<tr key={key}>
										<td className='tableDataTeamName'>
											<Link
												style={{
													textDecoration: 'none',
													color: 'black',
													fontWeight: 600,
												}}
												to={`/${player.playerId}/history`}
											>
												{player.firstName} {player.lastName}
											</Link>
											{' ('}
											{player.number}
											{')'}
										</td>

										<td>
											{isMobile440 && player.abbreviation
												? player.abbreviation
												: player.teamName}
										</td>

										<td>{player.divisionName}</td>
										<td>{player.goals + player.playoffGoals}</td>
										<td>{player.assists + player.playoffAssists}</td>
										<td>{player.gwg}</td>
										<td>{player.pim}</td>
										<td>{player.points}</td>
									</tr>
								))}
							</tbody>
						</table>
					)}

					{activeLeaderView === 'goalies' && (
						<table id='bottomRoster'>
							<thead>
								<tr>
									<th>Name</th>
									<th>Team</th>
									<th>Division</th>
									<th>GP</th>
									<th>W</th>
									<th>L</th>
									<th>SO</th>
									<th>GA</th>
									<th>GAA</th>
								</tr>
							</thead>

							<tbody>
								{displayedGoalies.map((goalie, key) => (
									<tr key={key}>
										<td className='tableDataTeamName'>
											<Link
												style={{
													textDecoration: 'none',
													color: 'black',
													fontWeight: 600,
												}}
												to={`/${goalie.playerId}/history`}
											>
												{goalie.firstName} {goalie.lastName}
											</Link>
											{' ('}
											{goalie.number}
											{')'}
										</td>

										<td>
											{isMobile440 && goalie.abbreviation
												? goalie.abbreviation
												: goalie.teamName}
										</td>

										<td>{goalie.divisionName}</td>
										<td>{goalie.gamesPlayed}</td>
										<td>{goalie.goalieWins || 0}</td>
										<td>{goalie.goalieLosses || 0}</td>
										<td>{goalie.goalieShutouts || 0}</td>
										<td>{goalie.goalsAgainst || 0}</td>
										<td>{goalie.gaa}</td>
									</tr>
								))}
							</tbody>
						</table>
					)}
				</div>
			)}

			{!isLoading && !loadedLeaders && (
				<div className='Leaders'>
					<h1>
						{leagueName} {divisionName && divisionName} - Stat Leaders
					</h1>

					<h2>
						{session} {year}
					</h2>

					<table id='players'>
						<thead>
							<tr>
								<th>Number</th>
								<th>Name</th>
								<th>Team</th>
								<th>Goals</th>
								<th>Assists</th>
								<th>PIM</th>
								<th>Total</th>
							</tr>
						</thead>
						<tbody></tbody>
					</table>
				</div>
			)}
		</React.Fragment>
	)
}

export default Leaders
